import { render } from "./MoneyComingInWidget.vue?vue&type=template&id=28990d6c"
import script from "./MoneyComingInWidget.vue?vue&type=script&lang=js"
export * from "./MoneyComingInWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__